package com.kinoshazam.screens.person.expanded

import androidx.compose.runtime.Composable
import presentation.screens.person.PersonMVIAction
import presentation.screens.person.PersonState

@Composable
actual fun ExpandedPersonWindow(
    state: PersonState,
    onAction: (PersonMVIAction) -> Unit,
) {
}
